export default "__VITE_ASSET__7uPQeRSg__";